import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import {
  Certificate,
  DigitalSection,
  DigitalSubmissionMeta,
} from '../../redux/types';
import ApiClient from '../../loopback/apiClient';
import { doDownloadCertificate } from '../DownloadDialog';

type Props = {
  digitalSection?: DigitalSection;
  digitalSubmissionMeta?: DigitalSubmissionMeta;
  hideCertificateButton?: boolean;
};

const EvaluationResult: React.FC<Props> = ({
  digitalSection,
  digitalSubmissionMeta,
  hideCertificateButton,
}: Props) => {
  const [cert, setCert] = useState<Certificate | undefined>(undefined);

  const onDownloadCertificate = async () => {
    if (cert) {
      doDownloadCertificate(cert.id, cert.file);
    }
  };

  useEffect(() => {
    const fetchCertificate = async () => {
      if (digitalSubmissionMeta) {
        const certificate = await ApiClient.getCertificate(digitalSubmissionMeta.enrollmentId);
        if (certificate.certificateTemplateId) {
          setCert(certificate);
        }
      }
    };

    fetchCertificate();
  }, [digitalSubmissionMeta]);

  const passed = digitalSubmissionMeta?.acquiredScore !== undefined
    && digitalSection?.passScore !== undefined
    && digitalSubmissionMeta.acquiredScore >= digitalSection.passScore;

  return (
    <>
      <Box sx={{ p: 2 }}>
        {
          (digitalSubmissionMeta?.acquiredScore !== undefined
            && digitalSection?.passScore !== undefined) && (
            <>
              <Typography variant="h5" sx={{ my: 2, ml: 2 }}>Result</Typography>
              <Typography component="div" sx={{ p: 2 }} gutterBottom>
                { /* eslint-disable-next-line max-len */}
                This is an overview of the passing score and the number of points actually achieved. You will receive more detailed information on your performance in comparison to other participants after the test period has ended.
              </Typography>
              <Box display="flex" justifyContent="space-between">
                <Box display="flex" sx={{ p: 1 }}>
                  <Typography component="div" sx={{ mx: 1 }}>Required Score</Typography>
                  <Typography component="div" sx={{ mx: 1, fontWeight: 500 }}>{digitalSection.passScore}</Typography>
                </Box>
                <Box display="flex" sx={{ p: 1 }}>
                  <Typography component="div" sx={{ mx: 1 }}>Acquired Score</Typography>
                  <Typography component="div" sx={{ mx: 1, fontWeight: 500 }}>{digitalSubmissionMeta.acquiredScore}</Typography>
                </Box>
                <Box display="flex" sx={{ p: 1 }}>
                  <Typography component="div" sx={{ mx: 1 }}>Result</Typography>
                  {
                    passed
                      ? <Typography component="div" style={{ color: '#3B8B43' }} sx={{ mx: 1, fontWeight: 500 }}>Passed</Typography>
                      : <Typography component="div" color="secondary" sx={{ mx: 1, fontWeight: 500 }}>Failed</Typography>
                  }
                </Box>
              </Box>
              <Box display="flex" justifyContent="flex-end" sx={{ mt: 3 }}>
                {
                  !hideCertificateButton && (
                    <Button
                      variant="contained"
                      color="tertiary"
                      onClick={onDownloadCertificate}
                      disabled={!passed || !cert}
                    >
                      Download Certificate
                    </Button>
                  )
                }
              </Box>
            </>
          )
        }
      </Box>
    </>
  );
};

export default EvaluationResult;
